import { combineReducers } from 'redux';

import apiError from './apiError';
import isExporting from './isExporting';
import visible from './visible';

/**
 * @typedef {{
 *  isExporting: boolean,
 *  apiError: string,
 *  visible: boolean,
 * }} StatisticsUIExportReducer
 */

export default combineReducers({
  visible,
  apiError,
  isExporting,
});
